import { render, staticRenderFns } from "./NotificationsMobile.vue?vue&type=template&id=ab893c5c&scoped=true"
import script from "./NotificationsMobile.vue?vue&type=script&lang=js"
export * from "./NotificationsMobile.vue?vue&type=script&lang=js"
import style0 from "./NotificationsMobile.vue?vue&type=style&index=0&id=ab893c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab893c5c",
  null
  
)

export default component.exports